'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = focusInterval;
/* istanbul ignore next: window not defined in test context, e.g. node */
function focusInterval(fn, interval, el) {
  var context = arguments.length <= 3 || arguments[3] === undefined ? window : arguments[3];

  var now = function now() {
    return new context.Date();
  };
  var timeLastRun = now();
  var timer = void 0;

  var stop = function stop() {
    if (timer) {
      context.clearTimeout(timer);
    }
  };

  var start = function start(time) {
    stop();
    timer = context.setTimeout(run, time || interval); // eslint-disable-line no-use-before-define
  };

  var run = function run() {
    timeLastRun = now();
    fn();
    start();
  };

  var focus = function focus() {
    var timeFocused = now();
    var timeSinceLastRun = timeFocused - timeLastRun;

    if (timeSinceLastRun >= interval) {
      run();
    } else {
      start(interval - timeSinceLastRun);
    }
  };

  el.addEventListener('blur', stop);

  el.addEventListener('focus', focus);

  return function () {
    stop();
    el.removeEventListener('focus', focus);
  };
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/focus-interval/dist/index.js
 ** module id = 586
 ** module chunks = 0
 **/